import { createFileRoute } from '@tanstack/react-router'
import { History } from 'lucide-react'
import { z } from 'zod'
import { ReplayScreen } from '@/screens/investigate/SCR-022-replay'

export const Route = createFileRoute('/_app/w/$ws/replay')({
  staticData: { screen: { id: 'SCR-022', title: 'Replay', group: 'Investigate', perm: 'replay.run', order: 5, description: 'See a past context delivery exactly as it was, and as it would be now.', icon: History } },
  validateSearch: z.object({ manifest: z.string().max(200).optional() }),
  component: ReplayScreen,
})
